import type { NavItem } from "./content";

export const siteNavItemsEn: NavItem[] = [
  { href: "/en", label: "Home" },
  { href: "/en/docs", label: "Docs" },
  { href: "/marketplace", label: "Marketplace" },
  { href: "/en/trust-settlement", label: "Trust & Settlement" },
  {
    label: "GitHub",
    children: [
      { href: "https://github.com/hejiajiudeeyu/delegated-execution-client", label: "Use locally", description: "CLI & local runtime" },
      { href: "https://github.com/nicekid1/delegated-execution-protocol", label: "Protocol", description: "Protocol spec" },
      { href: "https://github.com/hejiajiudeeyu/delegated-execution-platform-selfhost", label: "Self-host", description: "Self-host platform" },
      { href: "https://github.com/hejiajiudeeyu/delegated-execution-workspace", label: "Workspace", description: "Cross-repo orchestration" },
    ],
  },
];

export const siteHeaderActionsEn = [
  { href: "/en/docs/quick-start-responder", label: "Create a Hotline in 5 min", variant: "default" as const },
];
